import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { StyledButton } from "../../../../../Layout/Inputs/StyledButton";
import StyledPageMenuIcon from "../../../../../Layout/PageMenu/PageMenuIcon";

type Props = {
  readonly onClick: () => void;
};

export const InformationButton = ({ onClick }: Props) => {
  return (
    <StyledButton onClick={onClick} width="100%">
      <StyledPageMenuIcon icon={faInfo} /> Information
    </StyledButton>
  );
};
